export default __webpack_public_path__ + "static/media/Frame5.4924746b.png";